import React, { useEffect, useState } from "react";
import Dialog from "./Dialog";
import MoonLoader from "react-spinners/MoonLoader";
import theme, {
  roundness,
  styles as commonStyles,
} from "../../../utils/styles";

import { withBreakpoints } from "react-breakpoints";

const { cardWidth } = commonStyles.videos();
const iframePadding = 8;
const iframeWidth = cardWidth - iframePadding * 2;
const iframeHeight = iframeWidth - 100;

const Card = (props) => {
  const { video, index, listOfAllTags } = props;
  const { name, tags, link } = video;
  const sortedTags = tags.sort((a, b) => b.length - a.length);
  const id = index + "-" + name;

  const { breakpoints, currentBreakpoint } = props;
  const isBreakpoint = breakpoints[currentBreakpoint] < breakpoints.desktop;

  const [loading, setLoading] = useState(true);
  const [tagHover, setTagHover] = useState(false);
  const [tagHoverIndex, setTagHoverIndex] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    const element = document.getElementById(id);
    if (element !== null) {
      element.onload = () => {
        setLoading(false);
      };
    }
  });

  const renderSpinner = loading ? (
    <div style={styles.spinner}>
      <MoonLoader loading={true} color="#ffffff" speedMultiplier={1} />
    </div>
  ) : null;

  const renderFacebookIframe = link.includes("facebook.com") ? (
    <iframe
      src={`https://www.facebook.com/plugins/video.php?href=${link}`}
      id={id}
      title={id}
      width={iframeWidth}
      height={iframeHeight}
      style={styles.iframe}
      scrolling="no"
      frameBorder={0}
      allowtransparency="true"
      allowFullScreen={true}
    />
  ) : null;

  const renderYoutubeIframe = link.includes("youtube.com") ? (
    <iframe
      src={link}
      id={id}
      title={id}
      width={iframeWidth}
      height={iframeHeight}
      style={styles.iframe}
      scrolling="no"
      frameBorder={0}
      allowtransparency="true"
      allowFullScreen={true}
    />
  ) : null;

  const renderTitle = <div style={styles.title}>{name}</div>;

  const renderTags = (
    <div style={styles.tagsContainer}>
      {sortedTags.map((tag, index) => {
        let color;
        listOfAllTags.forEach((tagObj, index) => {
          if (tagObj.tag === tag) color = tagObj.color;
        });

        return (
          <div
            key={index}
            style={styles.tag(tagHover && tagHoverIndex === index, color)}
            onMouseEnter={(e) => {
              setTagHover(true);
              setTagHoverIndex(index);
            }}
            onMouseLeave={(e) => {
              setTagHover(false);
              setTagHoverIndex(null);
            }}
          >
            {tag}
          </div>
        );
      })}
    </div>
  );

  const renderOverlay = (
    <div
      style={styles.iframeOverlay}
      onClick={(e) => {
        setOpenDialog(true);
      }}
    />
  );

  const renderCard = (
    <div style={styles.root}>
      {renderSpinner}
      {renderOverlay}
      {renderFacebookIframe}
      {renderYoutubeIframe}
      {renderTitle}
      {renderTags}
    </div>
  );

  return (
    <>
      {renderCard}
      <Dialog
        open={openDialog}
        setOpen={setOpenDialog}
        {...props}
        isBreakpoint={isBreakpoint}
      />
    </>
  );
};

const styles = {
  root: {
    height: iframeHeight + 200,
    width: cardWidth,

    background: theme.colors.backgroundFaded,
    borderRadius: roundness.card,

    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "column",
  },

  iframe: {
    marginTop: iframePadding,
    marginBottom: iframePadding,
    border: "none",
    overflow: "hidden",
    borderRadius: roundness.card,
  },
  iframeOverlay: {
    position: "absolute",
    width: iframeWidth,
    height: iframeHeight,
    marginTop: iframePadding,
    marginBottom: iframePadding,
    overflow: "hidden",
    cursor: "pointer",
  },
  spinner: {
    position: "absolute",
    width: iframeWidth,
    height: iframeHeight,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "black",
    marginTop: iframePadding,
    marginBottom: iframePadding,
    borderRadius: roundness.card,
  },
  title: {
    marginBottom: iframePadding,
    marginTop: iframePadding,
    marginRight: iframePadding * 2,
    marginLeft: iframePadding * 2,
    fontSize: 13,
    color: "white",
    width: iframeWidth,
    height: 70,
  },
  tagsContainer: {
    width: iframeWidth,
    marginBottom: iframePadding,
    marginTop: iframePadding,
    marginRight: iframePadding * 2,
    marginLeft: iframePadding * 2,

    display: "flex",
    alignContent: "flex-start",
    justifyItems: "flex-start",
    flexWrap: "wrap",
    rowGap: 4,
    columnGap: 4,
  },
  tag: (hover, color) => ({
    fontSize: 12,
    color: "white",
    background: hover ? color + "95" : color + "50",
    padding: 4,
    borderRadius: 4,
    transition: "ease-in-out 0.3s",
    cursor: "pointer",
  }),
};

export default withBreakpoints(Card);
